/**
 * DOM Utilities - Helper functions for DOM manipulation
 */

const DOMUtils = {
  /**
   * Create an element from HTML string
   * @param {string} html - HTML string
   * @returns {Element} Created element
   */
  createFromHTML(html) {
    const template = document.createElement('template');
    template.innerHTML = html.trim();
    return template.content.firstChild;
  },

  /**
   * Query selector all shorthand
   * @param {string} selector - CSS selector
   * @param {Element} context - Context element
   * @returns {Element[]}
   */
  $$(selector, context = document) {
    return Array.from(context.querySelectorAll(selector));
  }
};

/**
 * Debounce function
 * @param {Function} fn - Function to debounce
 * @param {number} delay - Delay in milliseconds
 * @returns {Function} Debounced function
 */
function debounce(fn, delay = 300) {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), delay);
  };
}

/**
 * Throttle function
 * @param {Function} fn - Function to throttle
 * @param {number} limit - Limit in milliseconds
 * @returns {Function} Throttled function
 */
function throttle(fn, limit = 300) {
  let inThrottle;
  return function (...args) {
    if (!inThrottle) {
      fn.apply(this, args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
}

/**
 * Clamp a value between min and max
 * @param {number} value - Value to clamp
 * @param {number} min - Minimum value
 * @param {number} max - Maximum value
 * @returns {number}
 */
function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

/**
 * Escape HTML special characters
 * @param {string} str - String to escape
 * @returns {string}
 */
function escapeHTML(str) {
  const div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}

// Make available globally
window.DOMUtils = DOMUtils;
window.debounce = debounce;
window.throttle = throttle;
window.clamp = clamp;
window.escapeHTML = escapeHTML;
